import { render, staticRenderFns } from "./Paintings.vue?vue&type=template&id=5bd95732&scoped=true&"
import script from "./Paintings.vue?vue&type=script&lang=js&"
export * from "./Paintings.vue?vue&type=script&lang=js&"
import style0 from "./Paintings.vue?vue&type=style&index=0&id=5bd95732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd95732",
  null
  
)

export default component.exports